import React from 'react';
import { Button, ButtonProps, Icon } from '@chakra-ui/react';
import { ArrowLeft } from 'react-feather';
import Link from 'next/link';
import { useCurrentMerchantPath } from '@olo-web/utils/common/hooks';

type BackToMenuButtonProps = ButtonProps & {
  includeQueryParam?: boolean;
};

export const BackToMenuButton = ({ includeQueryParam, ...buttonProps }: BackToMenuButtonProps) => {
  const path = useCurrentMerchantPath({ includeQueryParam });
  return (
    <Button
      as={Link}
      href={path}
      shallow
      variant="tertiary"
      colorScheme="black"
      fontWeight="500"
      w="160px"
      leftIcon={<Icon as={ArrowLeft} h={5} w={5} />}
      {...buttonProps}
    >
      Back to menu
    </Button>
  );
};
